"use strict";

exports.__esModule = true;
exports.windowWrapper = exports["default"] = void 0;

var _window2 = _interopRequireDefault(require("./window.mock"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WindowWrapper = /*#__PURE__*/function () {
  function WindowWrapper() {
    this.reset();
  }

  var _proto = WindowWrapper.prototype;

  _proto.windowIsAvailable = function windowIsAvailable() {
    try {
      return typeof window !== 'undefined';
    } catch (e) {
      return false;
    }
  };

  _proto.reset = function reset() {
    this.isMock = !this.windowIsAvailable();
    this.window = this.isMock ? _window2["default"] : window;

    if (this.isMock) {
      this.window.mockInstanceId = Math.floor(Math.random() * 100000);
    }
  };

  return WindowWrapper;
}();

var windowWrapper = new WindowWrapper();
exports.windowWrapper = windowWrapper;
var _window = windowWrapper.window;
var _default = _window;
exports["default"] = _default;